import api from './api';

export default {
  getAll() { return api.get('/orders'); },
  getById(id: number) { return api.get(`/orders/${id}`); },
  create(data: any) { return api.post('/orders', data); },
  update(id: number, data: any) { return api.put(`/orders/${id}`, data); },
  delete(id: number) { return api.delete(`/orders/${id}`); }
};
